import { create } from 'zustand';

interface UnreadCountState {
  readonly unreadCount: number;
}

const useUnreadCountStore = create<UnreadCountState>(() => ({
  unreadCount: 0,
}));

export const useUnreadCount = () => useUnreadCountStore((state) => state.unreadCount);
export const setUnreadCount = (unreadCount: number) => useUnreadCountStore.setState({ unreadCount });
